import { type PostGamificationFormParticipationByFormIdData } from '@capsicum/common';
import { useQuery, type UseQueryOptions } from '@tanstack/react-query';

import { fetchGamificationFormById, type FetchGamificationFormByIdParams } from '../api/gamification-form';

export const gamificationFormKeys = {
	all: ['gamificationForm'] as const
};

export const useGamificationFormQueries = (
	params: FetchGamificationFormByIdParams,
	options?: Omit<UseQueryOptions<PostGamificationFormParticipationByFormIdData, unknown>, 'queryFn' | 'queryKey'>
) => {
	const { formId } = params;

	const getGamificationForm = () => {
		const queryParams: FetchGamificationFormByIdParams = {
			formId: formId
		};

		return fetchGamificationFormById(queryParams);
	};

	const { data, error, isFetched, isFetching, isLoading, refetch } = useQuery({
		queryFn: getGamificationForm,
		queryKey: [gamificationFormKeys.all, formId],
		...options
	});

	return { data, error, isFetched, isFetching, isLoading, refetch };
};
